// GA flipped 2026-05-21 — Have List SMS alerts are available to all users.
// This gate is now a no-op stub, kept so its call sites need no change and the flip
// is trivially reversible. A future cleanup PR can delete this file and inline-remove
// the now-dead gate branches at the call sites. The only remaining per-user gate is a
// verified phone — enforced server-side and surfaced via the bell's verify-phone CTA.
export function useCanUseHaveListAlerts(): boolean {
  return true;
}
